/**
 * What the server's HTTP 410 for a SkillFit interview invitation means, for the screens a candidate
 * can reach it from: the interview link itself, the step that opens the interview room from it, and
 * Start/Continue on the dashboard. The proctor's waiting screen reads it too, with its own wording.
 *
 * Two different things answer 410, and the candidate has a different next step for each:
 * - the invitation expired unused — their recruiter can send another;
 * - it was replaced by a re-interview — a newer invitation is already in their inbox, so asking the
 *   recruiter for one would be the wrong errand.
 */

const INVITATION_GONE_STATUS = 410;
const SKILLFIT_INVITATION_REPLACED_CODE = 'SKILLFIT_INVITATION_REPLACED';

export const INVITATION_REFUSAL_EXPIRED = 'expired';
export const INVITATION_REFUSAL_REPLACED = 'replaced';

export const INVITATION_EXPIRED_HEADING = 'This invitation has expired.';
export const INVITATION_EXPIRED_MESSAGE =
  'Interview invitations are valid for 72 hours. Please contact your recruiter — they can send you a new one.';
export const INVITATION_REPLACED_MESSAGE =
  'This interview link has been replaced. Please use the newest invitation we sent you.';

/**
 * `'replaced'`, `'expired'`, or null when the error is not a 410. A 410 with no code (an older
 * server) is read as expired, which is what every 410 meant before replacement existed.
 */
export const invitationRefusalKind = error => {
  if (!error || error.status !== INVITATION_GONE_STATUS) return null;
  return error.code === SKILLFIT_INVITATION_REPLACED_CODE
    ? INVITATION_REFUSAL_REPLACED
    : INVITATION_REFUSAL_EXPIRED;
};
